export const SITE = {
  name: "MBA Project & Thesis Writing Help",
  shortName: "MPTWH",
  tagline: "Academic writing, engineered for distinction.",
  phoneDisplay: "+91 90040 31722",
  phoneHref: "tel:+919004031722",
  whatsapp: "https://wa.me/919004031722",
  email: "ceo@mbaprojectreport.com",
  hours: "Mon–Sat, 9:00 AM – 9:00 PM IST",
};

export const STATS = [
  { value: "1,500+", label: "Projects Delivered" },
  { value: "900+", label: "Clients Served" },
  { value: "10+", label: "Years of Experience" },
  { value: "50+", label: "Expert Writers" },
];

export const whatsappWithText = (text) =>
  `${SITE.whatsapp}?text=${encodeURIComponent(text)}`;
